/**
 * @module ui/templates/election/party-leader-item
 */

import tgamConfig from "config/tgam";

/**
 * Returns party leader item HTML for partyLeaderInfo
 * @param {Object} partyLeaderInfo JSON object representing party leader's election result info.
 * @param {String} partyLeaderInfo.abbr - Party leader's abbreviated party name
 * @param {String} partyLeaderInfo.blurb - Party leader's votes difference blurb ("Leading/Behind/Lost/Elected by/with # votes.")
 * @param {String} partyLeaderInfo.diffStatus - Party leader's votes difference status ("", "increase", or "decrease")
 * @param {String} partyLeaderInfo.elected - Whether or not party leader has been elected in his/her riding ("Yes" or "No")
 * @param {String} partyLeaderInfo.headshotURL - Image URL for party leader's headshot
 * @param {Boolean} partyLeader.isPM - Whether or not the party leader is the new prime minister
 * @param {String} partyLeaderInfo.modifier - Party leader's party's CSS class modifier
 * @param {String} partyLeaderInfo.name - Party leader's full name
 * @param {String} partyLeaderInfo.partyName - Party leader's full party name
 * @param {String} partyLeaderInfo.rid - Party leader's riding ID
 * @returns {String} HTML for party leader item
 */
export function getPartyLeaderItem(partyLeaderInfo) {
  const isRidingWinner = partyLeaderInfo.elected === "Yes";
  const pmModifierClass = ` c-election-party-leaders__item--winner-pm  c-election-party-leaders__item--winner-pm--${partyLeaderInfo.modifier}`;//Modifier class to flag the new Prime Minister
  const indicatorHTML = `<span class="c-indicator-icon"><svg class="c-indicator-icon__art" role="img" pointer-events="none" focusable="false" aria-hidden="true"><use xlink: href="${tgamConfig.env.svgSpritePath}#icon-checkmark"></use></svg></span>`;
  const imageHtml = `<img src="${partyLeaderInfo.headshotUrl}" alt="Headshot of ${partyLeaderInfo.name}" class="c-election-party-leaders__headshot-image" />`;
  const dialogId = "js-modal-dialog-election-riding";

  return `<div class="c-election-party-leaders__item${partyLeaderInfo.isPM ? pmModifierClass : ""}">
            <div class="c-election-party-leaders__headshot">
              ${imageHtml}
            </div>
            <div class="c-election-party-leaders__data">
              <p class="c-election-party-leaders__party${isRidingWinner ? " c-election-party-leaders__party--winner" : ""} c-election-party-leaders__party--${partyLeaderInfo.modifier}">
                ${isRidingWinner ? indicatorHTML : ""}
                <abbr title="${partyLeaderInfo.partyName}" class="c-election-party-leaders__party-abbr">${partyLeaderInfo.abbr}</abbr>
              </p>

              <p class="c-election-party-leaders__leader">${partyLeaderInfo.name}</p>
              <a href="#" class="c-election-party-leaders__riding"
                data-riding-id="${partyLeaderInfo.rid}" data-leader-name="${partyLeaderInfo.name}"
                aria-haspopup="true" data-popup="${dialogId}">${partyLeaderInfo.ridingName}</a>

              <p class="c-election-party-leaders__difference c-election-party-leaders__difference--${partyLeaderInfo.diffStatus}">${partyLeaderInfo.blurb}</p>
            </div>
          </div>`;
}
